import Image1 from '../assets/Menu/Breakfast/Shahi-Tukda.jpg'
import Image2 from '../assets/Menu/Breakfast/Blueberry-Cheesecake.jpg'
import Image3 from '../assets/Menu/Breakfast/gulab jamun.jpg'
import Image4 from '../assets/Menu/Breakfast/paneer tikka dry.jpg'
import Image5 from '../assets/Menu/Breakfast/spring roll.jpg'
import Image6 from '../assets/Menu/Breakfast/manchurian.jpg'
import Image7 from '../assets/Menu/Breakfast/pani-puri.jpg'
import Image8 from '../assets/Menu/Breakfast/samosa.jpg'
import Image9 from '../assets/Menu/Breakfast/sev puri.jpg'
import Image10 from '../assets/Menu/Breakfast/Farm-House-Pizza.jpg'
import Image11 from '../assets/Menu/Breakfast/bk-whopper.jpg'
import Image12 from '../assets/Menu/Breakfast/pasta.jpg'
import Image13 from '../assets/Menu/Breakfast/caesar salad.jpg'
import Image14 from '../assets/Menu/Breakfast/Roasted-Corn-Salad.jpg'
import Image15 from '../assets/Menu/Breakfast/Mexican-Salad.jpg'
import Image16 from '../assets/Menu/lunch/paneer-butter-masala.jpg'
import Image17 from '../assets/Menu/lunch/Paneer-Tikka.jpg'
import Image18 from '../assets/Menu/lunch/paneer-bhurji.jpg'
import Image19 from '../assets/Menu/lunch/Subz Hara Masala.jpg'
import Image20 from '../assets/Menu/lunch/Nawabi-mixed-vegetable.jpg'
import Image21 from '../assets/Menu/lunch/aloo-gobi.jpg'
import Image22 from '../assets/Menu/lunch/roti.jpg'
import Image23 from '../assets/Menu/lunch/paratha.jpg'
import Image24 from '../assets/Menu/lunch/naan.jpg'
import Image25 from '../assets/Menu/lunch/dal makhni.jpg'
import Image26 from '../assets/Menu/lunch/dal-tadka.jpg'
import Image27 from '../assets/Menu/lunch/dal-fry.jpg'
import Image28 from '../assets/Menu/lunch/Jeera-Rice.jpg'
import Image29 from '../assets/Menu/lunch/veg-fried-rice.jpg'
import Image30 from '../assets/Menu/lunch/manchurian-fried-rice.jpg'
import Image31 from '../assets/Menu/lunch/dosa.jpg'
import Image32 from '../assets/Menu/Breakfast/choleb.jpg'
import Image33 from '../assets/Menu/Breakfast/uttapam.jpg'
import Image34 from '../assets/Menu/lunch/lunchThali.jpg'
import Image35 from '../assets/Menu/lunch/maxithali.jpg'
import Image36 from '../assets/Menu/lunch/exethali.jpg'
import Image37 from '../assets/Menu/Dinner/chole.jpg'

export const  Menu= [
    {
      "section_name": "Desserts",
      "items": [
        {
          "name": "Shahi-Tukda",
          "description": "Taste of royalty with Shahi Tukda, a bread-based festive dessert that’s sure to be a huge hit!.",
          "price": 70.00,
          "image": Image1
        },
        {
          "name": "Blueberry Cheesecake",
          "description": "[Eggless]. 120 gm. This slice is combination of creamy cheesecake, buttery crust, and vibrant blueberry filling flavor, all presented with a touch of French culinary elegance, creates a delicious dessert. (521 Calories, Protein-6g, Carbs-40g)",
          "price": 239.00,
          "image": Image2
        },
        {
          "name": "Gulab Jamun",
          "description": "Gulabjamun is a delicious Indian sweet consisting of dough balls soaked in a sugary syrup",
          "price": 40.00 ,
          "image": Image3
        }
      ]
    },
    {
      "section_name": "Starters",
      "items": [
        {
          "name": "Paneer Tikka Dry",
          "description": "[Calories: 681 kcal] [Contains Milk] Cottage cheese offered with your choice of marination.",
          "price": 219.00,
          "image": Image4
        },
        {
          "name": "Veg. Spring Roll",
          "description": "Spring rolls are a popular Chinese snack of crispy rolls filled with a savory mixed vegetables stuffing. ",
          "price": 109.00,
          "image": Image5
        },
        {
          "name": "Vegetable Manchurian",
          "description": "Super tasty deep fried vegetable dumplings mixed with delicious chinese gravy",
          "price": 239.00,
          "image": Image6
        }
      ]
    },
    {
      "section_name": "Appetizers",
      "items": [
        {
          "name": "Pani-Puri",
          "description": "crispy-fried puffed ball that is filled with potato, chickpeas, onions, spices, and flavoured water, usually tamarind or mint, and popped into one's mouth whole.",
          "price": 60.00,
          "image": Image7
        },
        {
          "name": "Samosa",
          "description": " deep-fried to a golden brown in vegetable oil, They are served hot and consumed with ketchup or chutney (mint, coriander, or tamarind)",
          "price": 50.00,
          "image": Image8
        },
        {
          "name": "Sev Puri",
          "description": "A fast-food savoury snack made from puffed rice, onions, tomatoes, cucumber and tangy tamarind sauce",
          "price": 80.00,
          "image": Image9
        }
      ]
    },
    {
      "section_name": "American and Italian",
      "items": [
        {
          "name": "Farm-House-Pizza",
          "description": "A pizza that goes ballistic on veggies! Check out this mouth watering overload of crunchy, crisp capsicum, succulent mushrooms and fresh tomatoes.",
          "price": 249.00,
          "image": Image10
        },
        {
          "name": "Veg Burger",
          "description": "The Plant-based Whopper® consists of a juicy flame-grilled, 100% plant-based*, sustainably sourced soy patty topped with freshly sliced tomatoes, fresh lettuce, creamy mayonnaise, ketchup, crunchy pickles, and sliced white onions on a toasted sesame seed bun.",
          "price": 129.00,
          "image": Image11
        },
        {
          "name": "Spinach Alfredo Pasta",
          "description": "Creamy and rich, yet never heavy, this Spinach Alfredo Pasta is an easy and satisfying comfort food.",
          "price": 149.00,
          "image": Image12
        }
      ]
    },
    {
      "section_name": "Salads",
      "items": [
        {
          "name": "Caesar Salad",
          "description": "Our Caesar salad takes the best from Julia Child's and Caesar Cardini's recipes: crisp inner romaine.",
          "price": 119.00,
          "image": Image13
        },
        {
          "name": "Roasted Corn Salad",
          "description": "Perfectly seasoned Roasted Corn Salad with sweet peppers is our new favorite summer salad.",
          "price": 139.00,
          "image": Image14
        },
        {
          "name": "Mexican Peanut Salad",
          "description": "Roasted Peanuts, Corn, Bellpepper, Tomatoes And Onion In Mexican Dressing.",
          "price": 149.00,
          "image": Image15
        }
      ]
    },
    { 
      "section_name": " Indian Main - Paneer ka Rutba",
      "items": [
        {
          "name": "Paneer Butter Masala",
          "description": "Soft Malai Paneer Batons Cooked Well In Authentic Buter Masala Tomato Gravy.",
          "price": 309.00,
          "image": Image16
        },
        {
          "name": "Paneer Tikka Masala",
          "description": "Paneer cooked in tandoor and toasted in red gravy.",
          "price": 299.00,
          "image": Image17
        },
        {
          "name": "Paneer Bhurji",
          "description": "Paneer Bhurji is a popular North Indian dish made with Indian cottage cheese aka paneer, herbs and ground spices.",
          "price": 289.00,
          "image": Image18
        }
      ]
    },
    { 
      "section_name": "Vegetable ka Rutba",
      "items": [
        {
          "name": "Veg Hara Masala",
          "description": "Cooked vegetable in spinach gravy.",
          "price": 269.00,
          "image": Image19
        },
        {
          "name": "Veg Nawabi",
          "description": "Cooked vegetable indian masala in spinach gravy.",
          "price": 279.00,
          "image": Image20
        },
        {
          "name": "Aloo Gobi",
          "description": "A delicious & flavor packed dish of spiced potatoes & cauliflower. Make the best aloo gobi.",
          "price": 199.00,
          "image": Image21
        }
      ]
    },
    { 
      "section_name": "Breads",
      "items": [
        {
          "name": "Roti Customizable",
          "description": "Made with pure Whole wheat flour.",
          "price": 19.00,
          "image": Image22
        },
        {
          "name": "Paratha Customizable",
          "description": "Made with pure Whole wheat flour.",
          "price": 24.00,
          "image": Image23
        },
        {
          "name": "Naan Customizable",
          "description": "Indian bread made of maida cooked in tandoor topped with butter..",
          "price": 15.00,
          "image": Image24
        }
      ]
    },
    { 
      "section_name": "Curries (Dal)",
      "items": [
        {
          "name": "Dal Makhani",
          "description": "North Indian dish where whole black lentils & red kidney beans are slow cooked with spices, butter & cream.",
          "price": 250.00,
          "image": Image25
        },
        {
          "name": "Dal Tadka",
          "description": "cooked spiced lentils are finished with a tempering made of ghee/ oil and spices.",
          "price": 200.00,
          "image": Image26
        },
        {
          "name": "Dal Fry",
          "description": "A basic Indian lentil dish - dal fry made with toor dal (split pigeon peas), spices & herbs.",
          "price": 190.00,
          "image": Image27
        }
      ]
    },
    { 
      "section_name": "Rice",
      "items": [
        {
          "name": "Jeera Rice",
          "description": " fluffy and aromatic Jeera Rice in under 15 minutes with an instant pot.",
          "price": 129.00,
          "image": Image28
        },
        {
          "name": "Schezwan Veg Fried Rice",
          "description": "Indo Chinese Veg Schezwan fried rice.",
          "price": 199.00,
          "image": Image29
        },
        {
          "name": "Manchurian Fried Rice",
          "description": "veg Manchurian fried rice features crispy Manchurian balls and rice cooked in a savory, rich sauce.",
          "price": 209.00,
          "image": Image30
        }
      ]
    }
  ]

  export const sampleMenu=[
    {
      "section_name": "BREAKFAST",
      "items": [
        {
          "item_name": "Masala Dosa",
          "description": "A dosa is South Indian, fermented crepe made from rice batter and black lentils.",
          "price": 145.00,
          "image": Image31
        },
        {
          "item_name": "Chole Bhature",
          "description": "It is a combination of chana masala (spicy white chickpeas) and bhatura/puri, a deep-fried bread made from maida.",
          "price": 179.00,
          "image": Image32
        },
        {
          "item_name": "Masala Uttapam",
          "description": "Masala Uttapam is a variety of uttapam which is made with cooked spicy potatoes fillings and is served with Coconut chutney and Uttapam Special Sambhar.",
          "price": 150.00,
          "image": Image33
        }
      ]
    },
    {
      "section_name": "LUNCH",
      "items": [
        {
          "item_name": "Maharaja Veg Thali", 
          "description": "Paneer Makhni, Mixed Veg Kadhai, 3 Tawa Rotis, Dal Makhni, Chef's Special Rice, Sweet Of The Day, Pickle, Salad, Raita.",
          "price": 329.00,
          "image": Image34
        },
        {
          "item_name": "Maxi Punjabi Thali",
          "description": "Paneer Makhni, Mixed Veg Kadhai, 3 Tawa Rotis, Jeera Rice, Dal Tadka, Pickle, Salad, Raita, Sweet Of The Day.",
          "price": 300.00,
          "image": Image35
        },
        {
          "item_name": "Executive Thali",
          "description": "Paneer Makhni, 3 Tawa Rotis, Dal Tadka, Chef's Special Rice, Pickle, Salad.",
          "price": 279.00,
          "image": Image36
        }
      ]
    },
    {
      "section_name": "DINNER",
      "items": [
        {
          "item_name": "Paneer Tikka Masala",
          "description": "Paneer Tikka Masala is made with(Indian cottage cheese), onions and peppers are marinated with yogurt and spices, grilled and then tossed in a creamy tomato based curry.",
          "price": 299.00,
          "image": Image17
        },
        {
          "item_name": "Paneer Butter Masala",
          "description": "Soft Malai Paneer Batons Cooked Well In Authentic Buter Masala Tomato Gravy Creamy and flavourful butter paneer.",
          "price": 309.00,
          "image": Image16
        },
        {
          "item_name": "Chole",
          "description": "chickpeas cooked to perfection with various spices, onions, tomatoes and herbs.",
          "price": 209.00,
          "image": Image37
        }
      ]
    }
  ]
